/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your date of birth to see your age.`)
};

const es_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu fecha de nacimiento para ver tu edad.`)
};

const de_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihr Geburtsdatum ein, um Ihr Alter zu sehen.`)
};

const nl_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer uw geboortedatum in om uw leeftijd te zien.`)
};

const fr_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez votre date de naissance pour voir votre âge.`)
};

const it_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la tua data di nascita per vedere la tua età.`)
};

const pt_br2_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite sua data de nascimento para ver sua idade.`)
};

const pt_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza a sua data de nascimento para ver a sua idade.`)
};

const ja_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生年月日を入力して、年齢を確認してください。`)
};

const zh_age_enter_dob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的出生日期以查看您的年龄。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_enter_dob = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_enter_dob(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_enter_dob", locale)
	if (locale === "en") return en_age_enter_dob(inputs)
	if (locale === "es") return es_age_enter_dob(inputs)
	if (locale === "de") return de_age_enter_dob(inputs)
	if (locale === "nl") return nl_age_enter_dob(inputs)
	if (locale === "fr") return fr_age_enter_dob(inputs)
	if (locale === "it") return it_age_enter_dob(inputs)
	if (locale === "pt-BR") return pt_br2_age_enter_dob(inputs)
	if (locale === "pt") return pt_age_enter_dob(inputs)
	if (locale === "ja") return ja_age_enter_dob(inputs)
	return zh_age_enter_dob(inputs)
};